// Legend clarifying the form convention: everything is required unless a field
// is explicitly marked "(opcional)". Render once at the top of every form.
export default function RequiredFieldsNote() {
  return (
    <p className="text-on-surface-light text-sm">
      Todos os campos são de preenchimento obrigatório, salvo os assinalados como{' '}
      <span className="italic">(opcional)</span>.
    </p>
  );
}
